import type { DomainConfig } from '@vista-digital/occ-domain'
import type { NestedPartial } from '@vista-digital/utilities'

export const getCustomDomainConfig = (): NestedPartial<DomainConfig> => {
    return {
        browsing: {
            maximumSelectedSites: 8,
        },
        order: {
            autofillMemberDetails: true,
        },
    }
}
